import React from "react";
import "./header.module.scss";

declare global {
  interface Window {
    general_settings: {
      brand_name: string;
      logo_white: string;
    };
  }
}

const Header: React.FC = () => {
  return (
    <header>
      <div>
        <img src={window.general_settings.logo_white} alt={`${window.general_settings.brand_name} image`} />
      </div>
    </header>
  );
};

export default Header;
